import { createStore } from "vuex";
import moduloDisparaAlertas from "./modules/disparaAlertas.js";

const store = createStore({
  modules: {
    moduloDisparaAlertas,
  },
});

export default store;
